<template>
  <div class="hello">
    <div class="title">😎 About me</div>
    <div>
      <b> # Who Am I 🤔 ? </b>
    </div>
    <br />
    <div>
      <p>
        🚀 Hi, I'm <b>Pongsatorn Nitithammwoot</b>, known as <b>Big</b>, and I'm
        currently the CTO at <a href="https://gowajee.ai">Gowajee.ai</a>, where
        we're focused on enterprise-grade Speech & Language AI technologies.
        🗣️🤖✨
      </p>
      <br />
      <p>
        🛠️ As a dedicated full-stack developer 👨🏻‍💻, I'm fully immersed in the
        realm of AI, particularly focused on Speech & Language technologies. At
        Gowajee.ai, we're crafting solutions that redefine communication,
        leveraging the power of machine learning and cutting-edge algorithms to
        elevate enterprise capabilities.
      </p>
      <br />
      <p>
        Join me on this thrilling journey as we harness the potential of Speech
        & Language AI tech to revolutionize the way enterprises interact and
        thrive in the digital landscape!
      </p>
    </div>
    <br />
    <hr />
    <br />
    <div>
      <ul>
        <li>
          <a href="https://github.com/biigpongsatorn">- Github</a>
        </li>
        <li>
          <a
            href="https://www.linkedin.com/in/pongsatorn-nitithammawoot-50b719152/"
            >- Linkin</a
          >
        </li>
        <li>
          <a href="https://twitter.com/0xbiig">- Twitter</a>
        </li>
      </ul>
    </div>
    <hr />
  </div>
</template>

<script>
export default {
  name: 'AboutMe'
}
</script>

<style scoped>
.hello {
  padding: 30px;
}
hr {
  float: left;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/AboutMe.vue